import { LivePrice } from 'redux/bydaMemberLookup/types';

export const MEMBER_LOOKUP_INVOICE_BANNER =
  'Your account is authorised for post-payment. An invoice will be sent to your registered email upon confirmation.';

const MEMBER_LOOKUP_STRIPE_DESCRIPTION =
  'Member contact extraction · One-time · Invoice';

function formatCentsAsDollars(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

function formatLivePriceAmount(livePrice: LivePrice): string {
  return `${formatCentsAsDollars(
    livePrice.unitAmount
  )} ${livePrice.currency.toUpperCase()}${
    livePrice.priceIncludeTax ? ' (inc. GST)' : ''
  }`;
}

export function buildMemberLookupInvoicePricing(livePrice: LivePrice) {
  const totalCents = livePrice.unitAmount;
  const currency = livePrice.currency.toUpperCase();
  const formattedAmount = formatCentsAsDollars(totalCents);

  return {
    bannerMessage: MEMBER_LOOKUP_INVOICE_BANNER,
    stripeAmount: formattedAmount,
    stripeCurrency: currency,
    stripeDescription: MEMBER_LOOKUP_STRIPE_DESCRIPTION,
    lineItems: [
      {
        label: 'Member contact list extraction',
        amount: formattedAmount,
        isHighlighted: true
      }
    ],
    total: {
      label: 'Total',
      amount: formatLivePriceAmount(livePrice)
    }
  };
}
